<div *ngIf="internalDocuments().length > 0" class="instruction">
  <span class="instruction-text">詳細は<cds-icon [icon]="plusIcon"></cds-icon>をクリックしてご確認ください。</span>
</div>
<cds-accordion #accordion>
  @if (isLoading()) {
  <div class="accordion-loading">
    <p>Loading documents...</p>
  </div>
  } @else if (internalDocuments() && internalDocuments().length > 0) {
  @for (doc of internalDocuments(); track trackByTitle($index, doc)) {
  <cds-accordion-panel #panel [title]="doc.title" [icon]="panel.expanded ? minusIcon : plusIcon" >
    
    <div [class]="contentClass">
      @if (doc.description) {
      <p [class]="descriptionClass" [innerHTML]="doc.description"></p>
      }

      @if (doc.guidelineText) {
      <div class="doc_content">
        <div class="doc-description">
          <p [class]="descriptionClass" [innerHTML]="doc.guidelineText">{{doc.guidelineText}}</p>
          @if (doc.disclaimers) {
          @for (item of doc.disclaimers; track $index) {
          <p class="doc-description__note">
            <span class="doc-description__note-marker">※</span>
            <span class="doc-description__note-text">
              {{item}}
            </span>
          </p>
          }
          }
        </div>

        <div class="doc-image-wrapper">
          @if (doc.title === '領収書とは' || doc.title === '領収書') {
          <img src="assets/images/receipt.png" alt="診断書サンプル" class="doc-image">
          }
          @else if (doc.title === '退院証明書とは' || doc.title === '退院証明書') {
          <img src="assets/images/discharge_certificate.png" alt="診断書サンプル" class="doc-image">
          }
          @else if (doc.title === '診断書') {
          <img src="assets/images/medical_certificate.png" alt="診断書サンプル" class="doc-image">
          }
          @else if (doc.title === '診療明細書とは' || doc.title === '診療明細書') {
          <img src="assets/images/medical_statement.png" alt="診断書サンプル" class="doc-image">
          }
        </div>
      </div>

      }

      @if (hasPoints(doc)) {
      <ul [class]="listClass">
        @for (point of doc.points; track trackByIndex($index)) {
        <li>{{ point }}</li>
        }
      </ul>
      }
    </div>
  </cds-accordion-panel>
  }
  }
</cds-accordion>